import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { Partner } from "@/components/Partner";
import { AjaxProducts } from "@/components/AjaxProducts";
import { Manifesto } from "@/components/Manifesto";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative min-h-screen bg-[#050505] text-white">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Partner />
      <AjaxProducts />
      <Manifesto />
      <QuoteForm />
      <Footer />
    </main>
  );
}
